import React from 'react';

// Barra cápsula com brilho e marcos de 25% — visual "Obsidian Star & Solar Gold"
export const StarProgressBar = ({ pct, achieved, testId, thin = false }) => (
  <div className={`relative w-full overflow-hidden rounded-full bg-black/60 ring-1 ring-inset ring-white/10 ${thin ? 'h-2' : 'h-3'}`}
    data-testid={testId}>
    <div className="absolute inset-0 flex justify-between px-[24%]">
      {[0, 1, 2].map((i) => <span key={i} className="w-px bg-white/10" />)}
    </div>
    <div className="relative h-full rounded-full"
      style={{
        width: `${Math.max(pct > 0 ? 3 : 0, Math.min(100, pct || 0))}%`,
        transition: 'width 0.9s cubic-bezier(0.16,1,0.3,1)',
        background: achieved
          ? 'linear-gradient(90deg,#10B981 0%,#34D399 100%)'
          : 'linear-gradient(90deg,#F59E0B 0%,#FBBF24 50%,#FDE68A 100%)',
        boxShadow: achieved
          ? '0 0 12px rgba(16,185,129,0.55)'
          : '0 0 12px rgba(245,158,11,0.55)',
      }} />
  </div>
);

// Tile escuro fosco com rótulo micro e valor em mono
export const MetaTile = ({ label, value, sub, testId, tone = 'gold' }) => {
  const toneMap = {
    gold: 'text-amber-300',
    emerald: 'text-emerald-300',
    rose: 'text-rose-300',
    white: 'text-white',
  };
  return (
    <div data-testid={testId}
      className="rounded-2xl border border-white/[0.07] bg-white/[0.04] p-3 backdrop-blur-md transition-colors duration-300 hover:border-amber-400/25 hover:bg-white/[0.06]">
      <p className="text-[9px] font-bold uppercase leading-tight tracking-[0.16em] text-zinc-500">{label}</p>
      <p className={`mt-1 font-mono text-sm font-bold leading-tight sm:text-base ${toneMap[tone]}`}>{value}</p>
      {sub && <p className="mt-0.5 text-[10px] leading-tight text-zinc-500">{sub}</p>}
    </div>
  );
};

// Moldura escura padrão das seções
export const ObsidianCard = ({ children, testId, className = '', aura = 'gold' }) => (
  <div data-testid={testId}
    className={`relative overflow-hidden rounded-3xl border border-white/[0.07] p-4 shadow-[0_20px_60px_-20px_rgba(0,0,0,0.8)] sm:p-5 ${className}`}
    style={{ background: 'linear-gradient(145deg,#0D111A 0%,#161D2C 50%,#0F172A 100%)' }}>
    <span aria-hidden className="pointer-events-none absolute inset-0"
      style={{
        background: aura === 'violet'
          ? 'radial-gradient(circle at 88% 8%, rgba(168,85,247,0.16) 0%, transparent 58%)'
          : 'radial-gradient(circle at 90% 10%, rgba(245,158,11,0.15) 0%, transparent 60%)',
      }} />
    <span aria-hidden className="pointer-events-none absolute inset-x-6 top-0 h-px"
      style={{ background: 'linear-gradient(90deg,transparent,rgba(251,191,36,0.45),transparent)' }} />
    <div className="relative">{children}</div>
  </div>
);

export const GRADE_GRADIENT = {
  A: 'linear-gradient(135deg,#F59E0B 0%,#D97706 100%)',
  S: 'linear-gradient(135deg,#38BDF8 0%,#0284C7 100%)',
  SS: 'linear-gradient(135deg,#A855F7 0%,#7E22CE 100%)',
};
